// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'
import App from './App'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueMeta)
Vue.use(VueI18n)

const loadLocaleMessages = () => {
  // json 파일을 읽어들이기 위한 function
  const requireLang = require.context('@/locales', true, /\.json$/)
  const messages = {}
  // json file read
  for (const file of requireLang.keys()) {
    if (file === './index.js') continue // index.js 파일 제외
    const path = file.replace(/(\.\/|\.json$)/g, '').split('/')
    path.reduce((o, s, i) => {
      if (o[s]) return o[s]
      o[s] = i + 1 === path.length ? requireLang(file) : {}
      return o[s]
    }, messages)
  }
  return messages
}

const options = {
  locale: 'en', // 기본언어 (영어)
  fallbackLocale: 'ko', // 지정한 언어에 번역이 없을 때 보여줄 언어 (한국어)
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
}

const i18n = new VueI18n(options)

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js